<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc"><a id="page10"></a><a id="page11"></a>Contents</h1>
<p class="toc1"><a class="hlink" href="#/OEBPS/ack.htm"><em>Acknowledgements</em></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/pref.htm"><em>Preface</em></a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/c01.htm">1 First steps to iniquity</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm">2 1933: the shadow of the swastika</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c03.htm">3 Towards disinheritance</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c04.htm">4 After the Nuremberg Laws</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c05.htm">5 ‘Hunted like rats’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c06.htm">6 ‘The seeds of a terrible vengeance’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c07.htm">7 September 1939: the trapping of Polish Jewry</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c08.htm">8 ‘Blood of innocents’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c09.htm">9 1940: ‘a wave of evil’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c10.htm">10 War in the West: terror in the East</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c11.htm">11 January–June 1941: the spreading net</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c12.htm">12 ‘It cannot happen!’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c13.htm">13 ‘A crime without a name’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c14.htm">14 ‘Write and record!’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c15.htm">15 The ‘final solution’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c16.htm">16 Eye-witness to mass murder</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c17.htm">17 20 January 1942: the Wannsee Conference</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c18.htm">18 ‘Journey into the unknown’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c19.htm">19 ‘Another journey into the unknown’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c20.htm">20 ‘If they have enough time, we are lost’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c21.htm">21 ‘Avenge our tormented people’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c22.htm">22 From Warsaw to Treblinka: ‘these disastrous and horrible days’</a></p>
<p class="toc1"><a id="page12"></a><a class="hlink" href="#/OEBPS/c23.htm">23 Autumn 1942: ‘at a faster pace’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c24.htm">24 ‘The most horrible of all horrors’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c25.htm">25 September–November 1942: the spread of resistance</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c26.htm">26 ‘To save at least someone’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c27.htm">27 ‘Help me get more trains’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c28.htm">28 Warsaw, April 1943: hopeless days of revolt</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c29.htm">29 ‘The crashing fires of hell’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c30.htm">30 ‘To perish, but with honour’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c31.htm">31 ‘A page of glory… never to be written’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c32.htm">32 ‘Do not think our spirit is broken’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c33.htm">33 ‘One should like so much to live a little bit longer’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c34.htm">34 From the occupation of Hungary to the Normandy landings</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c35.htm">35 ‘May one cry now?’</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c36.htm">36 July–September 1944: the last deportations</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c37.htm">37 September 1944: the Days of Awe</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c38.htm">38 Revolt at Birkenau</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c39.htm">39 Protectors and persecutors</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c40.htm">40 The death marches</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c41.htm">41 The ‘tainted luck’ of survival</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/b01.htm"><span class="small1">EPILOGUE:</span> ‘I will tell the world’</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/b03.htm"><em>Notes and sources</em></a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/index.htm"><em>Index</em></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?35017e98